const moment = require("moment/moment");

let navigateToMailPlatform = {
  methods: {
    emailLogin(){
      if(this.emailsLoading) return
      this.emailsLoading = true
      this.axios.get("/auth/emailIntegrationLink")
        .then(response => {
          this.emailsLoading = false
          if(response.data.error){
            console.log(response.data.error)
            this.$gNotify("Непредвиденная ошибка", "error")
            return
          }
          let a = document.createElement('a');
          a.href = response.data.link;
          a.target="_blank"
          a.click();
          // if(typeof window.open !== "function"){
          //   window.location.href = response.data.link
          // }else
          //   window.open(response.data.link, "_blank")
          // window.location.href = response.data.link
        })
        .catch(error => {
          this.emailsLoading = false
          console.log(error)
          this.$gNotify("Непредвиденная ошибка", "error")
        })
    }
  },
  data() {
    return {
      emailsLoading: false,
    }
  }
}

module.exports = navigateToMailPlatform